// import constants from './constants';

export default {
};



// WEBPACK FOOTER //
// ./src/store/modules/emailHistory/mutations.js